import { useEffect } from 'react'

function useGreyBody() {
  useEffect(() => {
    document.body.style.background = 'rgba(30, 30, 30, 0.9)'

    return () => {
      document.body.style.background = 'transparent'
    }
  })
}

export default useGreyBody


// WEBPACK FOOTER //
// ./src/hooks/useDarkBody.js